import React, { Component } from 'react';
import './Filters.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Tooltip from './Tooltip';

export default class IconButton extends Component {
	constructor(props){
		super(props)
		const {faIcon, imgUrl, text, onClick, className, disabled, tooltip} = props;
		this._callbackClick = onClick;
		this._elementRef = React.createRef();
		if(faIcon&&imgUrl)throw new Error('Both faIcon and imgUrl were provided');
		this._text = text;
		this._handleClick=this._handleClick.bind(this);
		this.state = { className:className, disabled:disabled===true?true:false, innerIcon :faIcon?(<FontAwesomeIcon className="icon" icon={faIcon} />):(<img src={imgUrl}/>)};
		this._tooltip = tooltip;
	}
	componentDidMount(){
		if(this._tooltip)
			Tooltip.register({element:this._elementRef.current, text:this._tooltip});
	}
	componentDidUpdate(previousProps){
		if(previousProps.className!==this.props.className||previousProps.disabled!==this.props.disabled)
			this.setState({className:this.props.className, disabled:this.props.disabled});
		if(previousProps.faIcon!==this.props.faIcon||previousProps.imgUrl!==this.props.imgUrl)
			this.setState({innerIcon :this.props.faIcon?(<FontAwesomeIcon className="icon" icon={this.props.faIcon} />):(<img src={this.props.imgUrl}/>)});
		if(previousProps.onClick!==this.props.onClick)
		{
			this._callbackClick=this.props.onClick;
		}
	}
	_handleClick(e){
		this._callbackClick(e);
	}
	render() {
		let className = "icon-button";
		if(this.state.className)
			className+=` ${this.state.className}`;
	return (<button className={className} disabled={this.state.disabled} ref={this._elementRef}>
				<div className="inner" onClick={this._handleClick}>
					<div className="icon">
					{this.state.innerIcon}
					</div>
					<div className="text">{this._text}</div>
				</div>
			</button>)
	}
}
